<template>
  <div>
    
     <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container-fluid">
        <button class="navbar-toggler" 
                type="button" 
                data-toggle="collapse" 
                data-target="#navbarSupportedContent" 
                aria-controls="navbarSupportedContent" 
                aria-expanded="false" 
                aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="logo-mob">
          <router-link :to="{ name: 'home' }">
            <img :src="logo.mini_logo ? logo.mini_logo : require('../assets/logo.png')">
          </router-link>
        </div>

        <div class="show-bg-size d-flex align-items-center">
          <li class="nav-item hidden-bg line-r" v-if="authenticated">
            <button
                type="button"
                name="button"
                class="navbar-action"
                data-toggle="dropdown">
              <div class="showDropdown">
                  <img :src="(avatar) ? avatar : require('../assets/img/avatar.jpg')" 
                      alt="" 
                      class="img-fluid" 
                      style="width:30px;height:30px;border-radius: 50%;">
                  <div class="dropdown-menu">
                    <router-link to="/me/profile" class="dropdown-item">Profile</router-link>
                    <a href="javascript:;" class="dropdown-item" @click="logout()">Logout</a>
                  </div>
              </div>
          </button>
          </li>

          <li class="nav-item hidden-bg line-r" v-if="!authenticated">
            <router-link to="/login" class="nav-link">
              <img src="../assets/images/icons/user.svg" alt="" class="svg-icon">
            </router-link>
          </li>

          <li class="nav-item hidden-bg">
            <button @click="toggleSearch = !toggleSearch" class="nav-link">
              <img v-if="!toggleSearch" src="../assets/images/icons/search.svg" alt="" class="svg-icon">
              <img v-else src="../assets/images/icons/cancel.svg" alt="" class="svg-icon">
            </button>
          </li>
        </div>


        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav nav-left"> <!-- mg-auto -->
              <li class="nav-item active"  v-if="(header[0]) ? header[0].status : false" >
                 <router-link
                    to="/accreditations" class="nav-link">Accreditation 
                    <span class="sr-only">(current)</span></router-link>
              </li>
              <li class="nav-item" v-if="(header[8]) ? header[8].status : false">
                <router-link class="nav-link"
                  to="/our-certificates">Certification</router-link>
              </li>
              <li class="nav-item" v-if="(header[1]) ? header[1].status : false" >
                  <router-link class="nav-link"
                        to="/programs">Programs</router-link>
              </li>
            </ul>
            <ul class="logo-ul">
              <li class="nav-item logo-img">
                <router-link class="d-flex align-items-center" :to="{ name: 'home' }">
                    <img :src="logo.mini_logo ? logo.mini_logo : require('../assets/logo.png')">
                    <div class="logo-title ml-2" v-html="logo.title ? logo.title: 'WSF'"></div>
                </router-link>
              </li>
            </ul>
            <ul class="navbar-nav nav-right"> <!-- mg-auto -->
            <li class="nav-item"  v-if="(header[2]) ? header[2].status : false">
              <router-link 
                        to="/memberships" class="nav-link">Membership</router-link>
            </li>
            <li class="nav-item" v-if="(header[3]) ? header[3].status : false" >
              <router-link 
                        to="/about" class="nav-link">About</router-link>
            </li>
            <li class="nav-item" v-if="(header[4]) ? header[4].status : false" >
              <router-link
                        to="/contact" class="nav-link">Contact Us</router-link>
            </li>
            <li v-for="(pg, idy) in pages" :key="'p'+idy" :class="(pg.has_header) ? '' : 'hidden' ">
                  <router-link :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                    class="nav-link">
                    {{ pg.title }}
                </router-link>
            </li>
            <li @click="opnPopular(pop.slug)"  class=" hidden-sm"
                v-for="(pop, idx) in popularSearch" :key="'s'+idx">
              <a href="javascript:;" class="nav-link" >{{ pop.title }}</a>
            </li>

            <!-- <button @click="searchAble = !searchAble">Search</button> -->

            <li class="remove-line d-none-ismall">
              <button v-if="authenticated"
                        type="button"
                        name="button"
                        class="navbar-action"
                        data-toggle="dropdown">
                      <div class="showDropdown">
                          <img :src="(avatar) ? avatar : require('../assets/img/avatar.jpg')" 
                              alt="" 
                              class="img-fluid" 
                              style="width:38px;height:38px;border-radius: 50%;">
                          <div class="dropdown-menu">
                            <router-link to="/me/profile" class="dropdown-item">Profile</router-link>
                            <a href="javascript:;" class="dropdown-item" @click="logout()">Logout</a>
                          </div>
                      </div>
                  </button>

                <li class="nav-item hidden-smmd line-r" v-if="!authenticated">
                  <router-link to="/login" class="nav-link">
                    <img src="../assets/images/icons/user.svg" alt="" class="svg-icon">
                  </router-link>
                </li>

                <li class="nav-item hidden-smmd">
                  <button @click="toggleSearch = !toggleSearch" class="nav-link">
                    <img v-if="!toggleSearch" src="../assets/images/icons/search.svg" alt="" class="svg-icon">
                    <img v-else src="../assets/images/icons/cancel.svg" alt="" class="svg-icon">
                  </button>
                </li>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <SearchPopup v-if="toggleSearch" />
  </div>
</template>


<style scoped>
.hidden { display: none !important }
.svg-icon:hover {
  opacity: 0.5;
}
.showDropdown {
  position: relative;
  padding: 0 10px;
}
.dropdown-menu {
  left: auto;
  right: 0;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {  }
@media (max-width: 767.98px) { 
  .d-none-ismall {
    display: none;
  }
  .show-bg-size  {
    position: relative;
    top: 7px;
  }
 }

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {  }

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {  }

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {  }

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) { 
  #navbarSupportedContent {
    display: flex !important;
    justify-content: space-between;
    align-items: center;
  }
  .logo-ul {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .navbar .logo-img {
    position: absolute;
    width: 120px;
    left: 50%;
    top: -10px;
    transform: translateX(-50%);
}
 }
</style>

<script>
import axios from "axios";
import SearchPopup from './SearchPopup';
export default {
  name: "Navbar",
  props: ['close'],
  components: {
    SearchPopup
  },
  data() {
    return {
      pgLoading: false,
      logo: [],
      header: [],
      pages: [],
      socials: [],
      searchPage: false,
      avatar: '',
      authenticated: false,
      searchAble: false,
      toggleSearch: false,
      popularSearch: []
    };
  },
  created() {

    // Get Navbar Links
    axios
      .get(window.baseURL + "/popularSearch")
      .then((res) => {
        var data = res.data.rows;
        this.popularSearch = res.data.rows;
      })
      .catch(() => {});

    if (this.$route.path == '/search') {
      this.searchPage = true;
    } else {
      this.searchPage = false;
    }
    
    if (!localStorage.getItem("access_token")) {
      this.authenticated = false;
    } else {
      this.authenticated = true;
    }

    if(!localStorage.getItem("avatar")) {
      this.avatar = false;
    } else {
      this.avatar = localStorage.getItem("avatar");
    }

    this.fetchLogo();
    this.fetchPages();
    this.scrollToTop();
  },
  mounted() {
    if ($(window).scrollTop() > 0) {
        $('#navigationBar').addClass('active');
    } 
    
    $(window).scroll(function () {
        if ($(window).scrollTop() > 0) {
            $('#navigationBar').addClass('active');
        } else {
            $('#navigationBar').removeClass('active');
        }
    });
  },
  methods: {
    //

    fetchLogo() {
      // Get Navbar Links
      axios
        .get(window.baseURL + "/setting")
        .then((res) => {
          var data = 
          this.logo = res.data.logo;
          this.socials = res.data.social;
          this.header = res.data.header;
        })
        .catch(() => {});
    },

    scrollToTop() {
      window.scrollTo(0,0);
    },  

    //Get Navbar Links in Big Sizes
    fetchPages(){
    axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});
    },

    logout(){
      localStorage.clear();
      this.$router.push({ name: 'login' });
    },

     opnPopular(slug) {
      this.$router.push({ name: "show-popular-search", params:{slug: slug }});
      // refersh
      location.reload();
    },

    openMenu() {
        let el1 = document.querySelector(".navbar-container");
        let el2 = document.querySelector(".navbar-backdrop");
        el1.classList.add('active');
        el2.classList.add('active');
    },

    closeMenu() {
        let el1 = document.querySelector(".navbar-container");
        let el2 = document.querySelector(".navbar-backdrop");
        el1.classList.remove('active');
        el2.classList.remove('active');
    }

  }
};
</script>
